const GIFTING_DETAILS_SUBTILE = "Corporate Gifting";
const GIFTING_DETAILS_BRIEF =
  "People that move around and get things done, have no use for gifts that sit idle! We at Wildcraft, are all about the active population. Spanning across a diverse range of categories, our products form the perfect head-to-toe outfit for aspiring Adventurers.";
const GIFTING_DETAILS_BANDWIDTH_SUBTILE = "The Wildcraft Bandwidth";
const GIFTING_DETAILS_LIST =
  '{"lists":[{"title":"IN HOUSE EXPERTISE","subpoints":["Custom designs, sourcing, quality testing and production led by internationally qualified experts"]},{"title":"OWNED MANUFACTURING SET UP","subpoints":["State-of-the-art production facility spanning across 1,75,000 sqft ","Uniquely developed, ‘one-of-its-kind’ machinery for greater efficiency and a finer finish  ","Equipped with Juki & Brother heavy duty sewing and specialized high-end machines"]},{"title":"STANDARDISED MATERIAL SOURCING","subpoints":["Superior lightweight fabric, webbing & bonded nylon thread, quality buckles, accessories and premium zippers & runners - sourced from globally established vendors"]},{"title":"WAREHOUSING AND LOGISTICS","subpoints":["All new, world-class warehouse, led by an extremely experienced team"]},{"title":"COMMITMENT TO QUALITY","subpoints":["5 year warranty promise  ","Rigorous testing of raw material at the in-house laboratory with heavy emphasis on functionality & durability"]}]}';
const GIFTING_DETAILS_CONCLUSION =
  "If your team is young, dynamic and passionate, they are going to love you for this.";

const REMARKS_FORM_TITLE = "GET IN TOUCH";
const REMARKS_FORM_BUTTON_TEXT = "SUBMIT";

const TOPSECTION_MOBILENUMBER = "+91  999999999";
const TOPSECTION_IMAGETEXT_1 = "GIFT YOUR TEAM AN ACTIVE LIFESTYLE.";
const TOPSECTION_IMAGETEXT_2 = "GET THEM WILDCRAFT.";

const GIFTINGENQUIRY_SUBHEADING =
  "Corporate, Institutional and International Enquiry";
const GIFTINGENQUIRY_STATEWISE =
  process.env.REACT_APP_WILDCFART_ORDER_ENQUIRY_CONTACT_LIST || "{}";
const GIFTINGENQUIRY_QUERIES =
  process.env.REACT_APP_WILDCRAFT_ORDER_QUERIES_CONTACT_LIST || "{}";

const COMMENDATIONCAROUSEL_ITEMS = [
  {
    id: "MERCEDES BENZ",
    brandLogo: "https://static.omuni.com/corporate-gifting/BenzLogo.png",
    brandText: `"We’re pleased to have done business with Wildcraft. The whole process went on smoothly without any hassle. The bags were delivered on time & the quality of was good too. Not to mention the fine handling of our order. You have responded to our telephonic calls and emails promptly & it will be our pleasure to do business with you again."`
  },
  {
    id: "CAPGEMINI",
    brandLogo: "https://static.omuni.com/corporate-gifting/CapgeminiLogo.png",
    brandText: `"We have been using Wildcraft items for a long time now and the experience has been good. That is the reason we came back to you for the customized bags. The bags are in good shape and the logo looks good on it."`
  },
  {
    id: "ROCKWELL COLLINS",
    brandLogo:
      "https://static.omuni.com/corporate-gifting/RockwellcollinLogo.png",
    brandText: `"We are extremely satisfied with the quality and design of the products supplied for RC India till date. Service of Wildcraft has been prompt and on time especially with delivery lines."`
  },
  {
    id: "ACCENTURE",
    brandLogo: "https://static.omuni.com/corporate-gifting/AccentureLogo.png",
    brandText: `"...I’d like to appreciate the efforts put in by Kandamaran for his order. With rigorous follow ups on order details, logistics, payment & services. He ensured that our entire consignment was pulled off without a hitch. Looking forward to working with you in the future as well! Thanks!"`
  },
  {
    id: "FIS GLOBAL",
    brandLogo: "https://static.omuni.com/corporate-gifting/FisLogo.png",
    brandText: `"I would like to thank Alen & Team for all their work. Their service has been exceptional and we are fully satisfied with the products we have received. The quick turnaround time on this request without compromising on the quality of delivery needs special mention. Thanks for your hard work and commitment."`
  }
];

const FORM_ERROR_MESSAGES = {
  MANDATORY: "Please input the mandatory fields",
  IMPROPER_PHONE: "Please enter a valid mobile number",
  SUCCESS: "Successfully Sent!",
  CIRCLE_SUCCESS: "Welcome to The CIRCLE! Thank you for signing up.",
  ERROR: "Oops! Something went wrong. Please try again",
  INVALID_NAME: "Please enter valid Name",
  INVALID_QUANTITY: "Please enter a valid quantity",
  INVALID_PINCODE: "Please enter a valid pincode"
};

const MESSAGE_TRIGGER_PARAMS = {
  templateId: "wildcraft_corporate_gifting",
  from: "care@wildcraft.com",
  subject: "Corporate Gifting Details",
  message: "corporate-gifting"
};

const CORPORATE_GIFTING_COMPONENTS = {
  MESSAGE_TRIGGER_PARAMS,
  FORM_ERROR_MESSAGES,
  GIFTING_DETAILS_SUBTILE,
  GIFTING_DETAILS_BRIEF,
  GIFTING_DETAILS_BANDWIDTH_SUBTILE,
  GIFTING_DETAILS_LIST,
  GIFTING_DETAILS_CONCLUSION,
  REMARKS_FORM_TITLE,
  REMARKS_FORM_BUTTON_TEXT,
  TOPSECTION_MOBILENUMBER,
  TOPSECTION_IMAGETEXT_1,
  TOPSECTION_IMAGETEXT_2,
  GIFTINGENQUIRY_STATEWISE,
  GIFTINGENQUIRY_QUERIES,
  COMMENDATIONCAROUSEL_ITEMS,
  GIFTINGENQUIRY_SUBHEADING
};

export default CORPORATE_GIFTING_COMPONENTS;
